export const createAccountData = [
    {
        key: 'CREATE_ACCOUNT_KEY',
        value: 'CREATE_ACCOUNT_VALUE',
        show: false
    }
]